import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import { Building2, User, Lock, Save, RefreshCw } from 'lucide-react';

const ProfilePage = () => {
  const { user, merchant, setUser, setMerchant } = useAuth();
  const [activeTab, setActiveTab] = useState('company');
  const [companyForm, setCompanyForm] = useState({
    company_name: merchant?.company_name || '',
    bin: merchant?.bin || '',
    address: merchant?.address || '',
    phone: merchant?.phone || '',
    bank_name: merchant?.bank_name || '',
    bank_account: merchant?.bank_account || '',
    bank_bik: merchant?.bank_bik || ''
  });
  const [passwordForm, setPasswordForm] = useState({ current: '', new_password: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const handleSaveCompany = async () => {
    setSaving(true);
    try {
      const res = await authAPI.updateProfile(companyForm);
      setMerchant(res.data.merchant);
      alert('Сохранено');
    } catch (err) {
      alert('Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = async () => {
    if (passwordForm.new_password !== passwordForm.confirm) {
      alert('Пароли не совпадают');
      return;
    }
    setSaving(true);
    try {
      await authAPI.changePassword({ current_password: passwordForm.current, new_password: passwordForm.new_password });
      setPasswordForm({ current: '', new_password: '', confirm: '' });
      alert('Пароль изменён');
    } catch (err) {
      alert(err.response?.data?.detail || 'Ошибка смены пароля');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white">Профиль</h1>

      <div className="flex gap-2 border-b border-slate-700 pb-4">
        <button onClick={() => setActiveTab('company')} className={`flex items-center gap-2 px-4 py-2 rounded-lg ${activeTab === 'company' ? 'bg-emerald-500/20 text-emerald-400' : 'text-slate-400 hover:bg-slate-700'}`}>
          <Building2 className="w-4 h-4" /> Компания
        </button>
        <button onClick={() => setActiveTab('user')} className={`flex items-center gap-2 px-4 py-2 rounded-lg ${activeTab === 'user' ? 'bg-emerald-500/20 text-emerald-400' : 'text-slate-400 hover:bg-slate-700'}`}>
          <User className="w-4 h-4" /> Пользователь
        </button>
        <button onClick={() => setActiveTab('security')} className={`flex items-center gap-2 px-4 py-2 rounded-lg ${activeTab === 'security' ? 'bg-emerald-500/20 text-emerald-400' : 'text-slate-400 hover:bg-slate-700'}`}>
          <Lock className="w-4 h-4" /> Безопасность
        </button>
      </div>

      {activeTab === 'company' && (
        <div className="card p-6 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-slate-400 mb-2">Название компании</label>
              <input value={companyForm.company_name} onChange={e => setCompanyForm(f => ({ ...f, company_name: e.target.value }))} className="input w-full" />
            </div>
            <div>
              <label className="block text-sm text-slate-400 mb-2">БИН</label>
              <input value={companyForm.bin} onChange={e => setCompanyForm(f => ({ ...f, bin: e.target.value }))} className="input w-full" />
            </div>
            <div className="sm:col-span-2">
              <label className="block text-sm text-slate-400 mb-2">Адрес</label>
              <input value={companyForm.address} onChange={e => setCompanyForm(f => ({ ...f, address: e.target.value }))} className="input w-full" />
            </div>
            <div>
              <label className="block text-sm text-slate-400 mb-2">Телефон</label>
              <input value={companyForm.phone} onChange={e => setCompanyForm(f => ({ ...f, phone: e.target.value }))} className="input w-full" />
            </div>
          </div>

          <h4 className="text-white font-medium pt-4 border-t border-slate-700">Реквизиты для выплат</h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm text-slate-400 mb-2">Банк</label>
              <input value={companyForm.bank_name} onChange={e => setCompanyForm(f => ({ ...f, bank_name: e.target.value }))} className="input w-full" />
            </div>
            <div>
              <label className="block text-sm text-slate-400 mb-2">Счёт</label>
              <input value={companyForm.bank_account} onChange={e => setCompanyForm(f => ({ ...f, bank_account: e.target.value }))} className="input w-full font-mono" />
            </div>
            <div>
              <label className="block text-sm text-slate-400 mb-2">БИК</label>
              <input value={companyForm.bank_bik} onChange={e => setCompanyForm(f => ({ ...f, bank_bik: e.target.value }))} className="input w-full font-mono" />
            </div>
          </div>

          <button onClick={handleSaveCompany} disabled={saving} className="btn-primary flex items-center gap-2">
            <Save className="w-4 h-4" /> {saving ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      )}

      {activeTab === 'user' && (
        <div className="card p-6 space-y-4">
          <div>
            <label className="block text-sm text-slate-400 mb-2">Имя</label>
            <input value={user?.name || ''} readOnly className="input w-full" />
          </div>
          <div>
            <label className="block text-sm text-slate-400 mb-2">Email</label>
            <input value={user?.email || ''} readOnly className="input w-full" />
          </div>
          <div>
            <label className="block text-sm text-slate-400 mb-2">Роль</label>
            <input value={user?.role || ''} readOnly className="input w-full" />
          </div>
        </div>
      )}

      {activeTab === 'security' && (
        <div className="card p-6 space-y-4">
          <h4 className="text-white font-medium">Сменить пароль</h4>
          <div>
            <label className="block text-sm text-slate-400 mb-2">Текущий пароль</label>
            <input type="password" value={passwordForm.current} onChange={e => setPasswordForm(f => ({ ...f, current: e.target.value }))} className="input w-full" />
          </div>
          <div>
            <label className="block text-sm text-slate-400 mb-2">Новый пароль</label>
            <input type="password" value={passwordForm.new_password} onChange={e => setPasswordForm(f => ({ ...f, new_password: e.target.value }))} className="input w-full" />
          </div>
          <div>
            <label className="block text-sm text-slate-400 mb-2">Повторите пароль</label>
            <input type="password" value={passwordForm.confirm} onChange={e => setPasswordForm(f => ({ ...f, confirm: e.target.value }))} className="input w-full" />
          </div>
          <button onClick={handleChangePassword} disabled={saving} className="btn-primary flex items-center gap-2">
            <Lock className="w-4 h-4" /> {saving ? 'Сохранение...' : 'Изменить пароль'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
